// extracted by mini-css-extract-plugin
export default {"container":"main_container_r9CAs","links_container":"main_links_container_urz80","wrapper":"main_wrapper_KLis1"};